export default __webpack_public_path__ + "static/appsflame-7e0a6cf71fe70409008f3c9ca043b569.svg";